<div class="or-pt-32-px or-mx-24-px action-push-modal">
  <div class="or-d-flex or-justify-content-center">
    <span class="or-head-xl or-mb-16-px or-text-align-center">Czym są Osiągnięcia?</span>
  </div>

  <img class="or-mb-20-px or-w-100-pc" src="assets/action-push/achievements.jpg" />

  <div class="or-text-lg or-mb-20-px">
    Im częściej będziesz korzystał z Orlikfy, tym więcej osiągnięć zdobędziesz! Oprócz odznak w profilu, każde
    osiągnięcie daje kolejną liczbę punktów do Twojego profilu!
  </div>
</div>

<div class="or-mb-12-px or-mx-24-px or-mt-12-px">
  <button class="button-primary-style or-h-48-px or-head-md or-w-100-pc or-mb-12-px" (click)="handleAction()">
    Zobacz wszystkie osiągnięcia
  </button>

  <button class="button-secondary-style or-h-48-px or-head-md or-w-100-pc" (click)="closeModal()">
    Wróć do głównego ekranu
  </button>
</div>
